import { ChangeEvent } from 'react';
import { CoreBox, CoreCheckbox, CoreFormControl, CoreTextField } from '@youscience/core';

import { CUSTOM_CHECKPOINT_ERRORS, MAX_CHECKPOINT_LABEL_LENGTH } from '@constants/applyingSchoolsPlanner';

import { FormState } from '@interfaces/applications';

import MarkIcon from '@images/mark.svg?react';
import DeleteCheckpointIcon from '@images/delete-checkpoint.svg?react';
import AddIcon from '@images/plus-button.svg?react';

import {
  sxStyles,
  StyledCustomCheckpointCheckBox,
  StyledTextFieldCounter,
  StyledTextFieldIcons,
  StyledActionIcon,
} from './PlannerSchoolCardAddCheckpoint.styles';
import ActionButton from '@components/ActionButton';

interface AddCheckpointProps {
  formState: FormState;
  isShowTextField: boolean;
  onAddCustomCheckpoint: () => void;
  onCustomCheckpointChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  onCustomCheckpointLabelChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCloseTextField: () => void;
  onClickAddCheckpoint: () => void;
}

export const PlannerSchoolCardAddCheckpoint = (props: AddCheckpointProps) => {
  const {
    formState,
    isShowTextField,
    onAddCustomCheckpoint,
    onCustomCheckpointChange,
    onCustomCheckpointLabelChange,
    onCloseTextField,
    onClickAddCheckpoint,
  } = props;

  return (
    <>
      {isShowTextField ? (
        <StyledCustomCheckpointCheckBox>
          <CoreCheckbox checked={formState.customCheckpoint.value} onChange={onCustomCheckpointChange} />

          <CoreBox sx={sxStyles.textFieldWrap}>
            <CoreFormControl fullWidth>
              <CoreTextField
                sx={sxStyles.formHelperText}
                error={!!formState.helperText}
                value={formState.customCheckpoint.label}
                autoFocus
                label="Add your item to complete"
                onChange={onCustomCheckpointLabelChange}
                helperText={CUSTOM_CHECKPOINT_ERRORS[formState.helperText]}
              />
              {formState.customCheckpoint.label.length > 0 && (
                <StyledTextFieldCounter isError={!!formState.helperText} variant="caption">
                  {`(${formState.customCheckpoint.label.length}/${MAX_CHECKPOINT_LABEL_LENGTH})`}
                </StyledTextFieldCounter>
              )}
            </CoreFormControl>
          </CoreBox>

          <StyledTextFieldIcons>
            <StyledActionIcon>
              <DeleteCheckpointIcon data-testid="cancelIcon" onClick={onCloseTextField} />
            </StyledActionIcon>

            <StyledActionIcon>
              <MarkIcon data-testid="saveIcon" onClick={onAddCustomCheckpoint} />
            </StyledActionIcon>
          </StyledTextFieldIcons>
        </StyledCustomCheckpointCheckBox>
      ) : null}

      <CoreBox sx={{ paddingTop: '1.5rem' }}>
        <ActionButton
          variant="text"
          data-testid={isShowTextField ? 'disabledChecklistItemBtn' : 'activeChecklistItemBtn'}
          disabled={isShowTextField}
          onClick={onClickAddCheckpoint}
          startIcon={<AddIcon />}
        >
          Add checklist item
        </ActionButton>
      </CoreBox>
    </>
  );
};
